// removed by extract-text-webpack-plugin
module.exports = {"header":"ReadyToJoin__header__mXTTo","form-container":"ReadyToJoin__form-container__2Ecd_","scrollable":"ReadyToJoin__scrollable__2E2u7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NovemberPromotions/ReadyToJoin/ReadyToJoin.scss
// module id = 692
// module chunks = 0